import * as React from 'react'
import { useFeatureFlagV2 } from '@/hooks'

const ZENDESK_SCRIPT_ID = 'ze-snippet'
const ZENDESK_SRC = 'https://static.zdassets.com/ekr/snippet.js?key=3838f5c8-de54-4f0b-9fc2-d612d05738f4'

type ZendeskWidgetProps = {
  subDomain: string
}

/** Horizontal space (px) the floating launcher occupies in the bottom-right corner; floating UI pinned there should keep clear of it. */
export const ZENDESK_LAUNCHER_CLEARANCE_PX = 100

export const ZendeskWidget = ({ subDomain }: ZendeskWidgetProps): null => {
  const isEnabled = useFeatureFlagV2('zendesk-widget', subDomain)

  React.useEffect(() => {
    if (!isEnabled) return
    if (document.getElementById(ZENDESK_SCRIPT_ID)) return

    const script = document.createElement('script')
    script.id = ZENDESK_SCRIPT_ID
    script.src = ZENDESK_SRC
    script.async = true
    document.body.appendChild(script)
  }, [isEnabled])

  return null
}
